import React, { useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '../Icons/search';
import { isEmpty, get } from '../../../utils/lodash';
import { Box, InputBase, ClickAwayListener, Typography, Link } from '@material-ui/core';
import settings from '../../../utils/settings';
import I18n from '../../../config/locales';
import Filter from './filter';
import SwitchFilter from './switchFilter';

const useStyles = makeStyles(theme => ({
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0
  },
  search: {
    position: 'relative',
    height: theme.spacing(5),
    display: 'flex',
    alignItems: 'center',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '1px solid #70707080',
    borderRadius: theme.spacing(0.75),
    padding: theme.spacing(0, 1.5),
    width: '93%',
    margin: theme.spacing(1, 0, 1, 1),
    [theme.breakpoints.down('xs')]: {
      width: '85%'
    }
  },
  inputField: {
    fontSize: 13,
    letterSpacing: 0,
    width: 'calc(100% - 32px)',
    '& input': {
      '&::placeholder': {
        textOverflow: 'ellipsis !important'
      }
    }
  },
  searchWrapper: {
    display: 'flex'
  },
  searchListWrapper: {
    position: 'absolute',
    marginTop: theme.spacing(7),
    zIndex: 3,
    backgroundColor: 'white',
    width: theme.spacing(33.5),
    padding: theme.spacing(1, 1.5),
    boxShadow: '0px 0px 8px #00000029',
    maxHeight: theme.spacing(30),
    overflow: 'scroll',
    display: 'flex',
    flexDirection: 'column'
  },
  searchList: {
    padding: theme.spacing(1, 0),
    color: theme.palette.tertiary.main,
    fontSize: 15
  },
  noResult: {
    padding: theme.spacing(1, 0),
    fontSize: 15,
    opacity: 0.7
  }
}));
const Search = props => {
  const classes = useStyles();
  const [ showSearchResult, setShowSearchResult ] = useState(false);
  const [ searchValue, setSearchValue ] = useState('');
  const {
    searchList = [],
    getSearchResult = () => {},
    field = '',
    handleChange = () => {},
    savedSearch,
    systemSearch,
    activationSavedSearch,
    handleFilterChange,
    handleFilterReset,
    selectedFilter
  } = props;

  const handleSearch = e => {
    const newValue = e.target.value;
    setSearchValue(newValue);
    getSearchResult(newValue, field);
  };
  return (
    <div className={classes.root}>
      <ClickAwayListener onClickAway={() => setShowSearchResult(false)}>
        <Box className={classes.searchWrapper}>
          <Box className={classes.search}>
            <Box className={classes.searchIcon}>
              <SearchIcon />
            </Box>
            <InputBase
              value={searchValue}
              onChange={e => handleSearch(e)}
              onFocus={() => setShowSearchResult(true)}
              className={classes.inputField}
              placeholder={I18n.t('dashboard.search')}
              inputProps={{ 'aria-label': 'search' }}
              disabled={field === 'Leads'}
            />
          </Box>
          {showSearchResult && searchValue && !isEmpty(searchList) ? (
            <Box className={classes.searchListWrapper}>
              {searchList.result && searchList.result.length && searchList.result.length > 0 ? (
                <Fragment>
                  {searchList.result.map((list, index) => {
                    const url = list.is_activation ? `activations/edit/${list.id}` : `systems/${list.id}`;
                    const label = get(list, 'id', '') ? (
                      <Link
                        target="_blank"
                        key={index}
                        href={settings.enlightenMenuUrl(url)}
                        className={classes.searchList}
                      >
                        {list.label}
                      </Link>
                    ) : (
                      <Typography className={classes.noResult}>
                        {get(list, 'label', '') || I18n.t('dashboard.noResult')}
                      </Typography>
                    );
                    return label;
                  })}
                </Fragment>
              ) : (
                <Typography className={classes.noResult}>{I18n.t('dashboard.noResult')}</Typography>
              )}
            </Box>
          ) : (
            <Fragment />
          )}
          {(field === 'Alerts' || field === 'Activations') && (
            <Filter
              savedSearch={savedSearch}
              systemSearch={systemSearch}
              activationSavedSearch={activationSavedSearch}
              handleFilterChange={handleFilterChange}
              handleFilterReset={handleFilterReset}
              field={field}
              selectedFilter={selectedFilter}
            />
          )}
          {field === 'Leads' && <SwitchFilter handleChange={handleChange} />}
        </Box>
      </ClickAwayListener>
    </div>
  );
};

export default Search;
